/**
 * Chip Scroll Handlers for Native Interactive Site Map (ISM)
 *
 * Pure DOM event delegation — no Redux, no CSS, no business logic. Reports horizontal
 * scrolling on the map chips bar,
 * debounced so one scroll gesture fires one callback instead of one per scroll tick. Mobile-only
 * gating is the caller's responsibility (see plugins/tracking.plugin.js) — this module doesn't
 * know about breakpoints.
 *
 * @module nativeInteractiveSiteMap/handlers/chipScrollHandlers
 */
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

const SCROLL_DEBOUNCE_MS = 300;

function createChipScrollHandlers() {
  const state = {
    subscription: null,
  };

  /**
   * @param {HTMLElement} element - the chips wrapper element
   * @param {() => void} onScrolled
   */
  function bind(element, onScrolled) {
    state.subscription = fromEvent(element, 'scroll', { passive: true })
      .pipe(debounceTime(SCROLL_DEBOUNCE_MS))
      .subscribe(onScrolled);
  }

  function unbind() {
    state.subscription?.unsubscribe();
    state.subscription = null;
  }

  return { bind, unbind };
}

export default createChipScrollHandlers;
